import { render, staticRenderFns } from "./LargeLogo.vue?vue&type=template&id=68a04122&scoped=true&"
import script from "./LargeLogo.vue?vue&type=script&lang=js&"
export * from "./LargeLogo.vue?vue&type=script&lang=js&"
import style0 from "./LargeLogo.vue?vue&type=style&index=0&id=68a04122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a04122",
  null
  
)

export default component.exports